import { useState } from 'react';
import { Checkbox, Form } from 'antd';
import { FormContentLayout } from '../FormContentLayout';
// import 'antd/dist/antd.css';
import styles from './index.module.css';
import { EddLayout } from '../EddLayout';
import { EddSteps, WORKING_DAYS_FORM_NAME } from '../../constants';
import { ButtonPair } from '../ButtonPair';

type CheckboxValueType = string | number | boolean;

const WORKING_DAYS_TITLE = 'Which days of the week do you process orders?';
const WORKING_DAYS_DESCRIPTION = "We'll use this information to calculate your business days.";

const OPTIONS = [{ label: 'Sun', value: 6 },
  { label: 'Mon', value: 0 }, { label: 'Tues', value: 1 }, { label: 'Wed', value: 2 },
  { label: 'Thur', value: 3 }, { label: 'Fri', value: 4 }, { label: 'Sat', value: 5 }];

const WorkingDays = () => {
  const form = Form.useFormInstance();
  const initialValue = form.getFieldValue(WORKING_DAYS_FORM_NAME);
  const [value, setValue] = useState<CheckboxValueType[]>(initialValue);
  const handleValueChange = (data: CheckboxValueType[]) => {
    setValue(data);
    form.setFieldValue(WORKING_DAYS_FORM_NAME, data);
  };
  return (
    <EddLayout left={(
      <FormContentLayout
        title={WORKING_DAYS_TITLE}
        description={WORKING_DAYS_DESCRIPTION}
        step={EddSteps.SECOND}
      >
        <div className={styles.checkboxGroup}>
          <Checkbox.Group options={OPTIONS} value={value} onChange={handleValueChange} />
        </div>
        <ButtonPair step={EddSteps.SECOND} disableNext={!value || value.length === 0} />
      </FormContentLayout>
    )}
    />
  );
};

export { WorkingDays };
